import React, { useState } from "react";
import OtpVerify from "./OtpVerify";
import myLogo from "../images/myLogo.png";
import "../styleSheets/login.css";

function Login() {
  const [email, setEmail] = useState("");
  const [message, setmessage] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const onChangeEmail = (e) => {
    setEmail(e.target.value);
    if (error) setError("");
  };

  const onClickGenerate = async (e) => {
    e.preventDefault();

    if (!email.trim()) {
      setError("Email is required");
      return;
    }

    if (!isValidEmail(email)) {
      setError("Please enter a valid email address");
      return;
    }

    setError("");
    setLoading(true); // 🔥 start spinner

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/auth/otp/send`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        },
      );

      const result = await response.json();
      setmessage(result);
    } catch (err) {
      setError("Something went wrong. Try again.");
    }

    setLoading(false); // 🔥 stop spinner
  };

  return (
    <div className="d-flex flex-column justify-content-center align-items-center login-container">
      <div className="login-card">
        <img className="login-logo" src={myLogo} />

        <form onSubmit={onClickGenerate}>
          <div class="mb-3 input-cont">
            <div>
              <input
                type="email"
                className={`form-control input-mail login-input ${error ? "error" : ""}`}
                id="email"
                name="email"
                value={email}
                aria-describedby="emailHelp"
                onChange={onChangeEmail}
                placeholder="Enter Your Email...."
              />
              {error && <p className="login-error">{error}</p>}
            </div>

            <button
              type="submit"
              className="btn btn-outline-primary mx-2 d-flex align-items-center justify-content-center gap-2"
              disabled={loading}
            >
              {loading && (
                <span className="spinner-border spinner-border-sm"></span>
              )}

              {loading ? "Sending..." : "Get OTP"}
            </button>
          </div>
          <div className="text-center">
            {message && <p>{message.message}</p>}
          </div>
        </form>

        <OtpVerify email={email} />
      </div>
    </div>
  );
}

export default Login;
